import React, {Component} from 'react'
import {addLineItems} from '../../utils/Cart'

class CheckoutOrderBump extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className='bump-variant'>
        {
          this.props.variant.featured_image && 
          <img src={this.props.variant.featured_image.src} alt={this.props.variant.featured_image.alt} style={{width: '64px', height: 'auto', marginRight: '8px'}} />
        }
        <div className='bump-variant-content'>
          <div className='bump-variant-text' style={{width: 'calc(100%-9rem)'}}>
            <p className='bump-variant-title'>{this.props.variant.name}</p>
            { this.props.description && <span dangerouslySetInnerHTML={{ __html: this.props.description }} /> }
          </div>
          <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-end'}}>
            <span style={{fontWeight: '700'}}>${ parseFloat(this.props.variant.price / 100.0).toLocaleString(undefined, { maximumFractionDigits: 2 }) }</span>
            <button className='bump-variant-btn' onClick={(e) => {e.target.disabled = true; addLineItems((cart) => {location.reload()}, [{id: this.props.variant.id, quantity: 1}], false)}}>Add it!</button>
          </div>
        </div>
      </div>
    )
  }
}

export default CheckoutOrderBump